"use client";

import { usePathname } from "next/navigation";
import { RecognizedTab, recognizedTabs } from "./UatBreadCrumb";
import MobileNav from "./MobileNav";
import { useTranslations } from "use-intl";
type UatMobileNavProps = {
  institutionSlug: string;
};
export default function UatMobileNav(props: UatMobileNavProps) {
  const pathname = usePathname();
  const [_bp, rest] = pathname.split(`/uat/${props.institutionSlug}`);
  const currentTab = rest!.split("/").filter(Boolean)[0];
  const crumb = recognizedTabs[currentTab as RecognizedTab];
  const t = useTranslations("institution");
  if (!crumb) return null;
  return <MobileNav pageItem={{
    href: `/${props.institutionSlug}/${crumb.href}`,
    label: t(crumb.tl),
    icon: <crumb.icon size={20} />
  }} data-sentry-element="MobileNav" data-sentry-component="UatMobileNav" data-sentry-source-file="UatMobileNav.tsx" />;
}